// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fast-search[data-v-de59e63e] input {\r\n  text-transform: uppercase;\n}\n.fast-search-type[data-v-de59e63e] {\r\n  max-width: 8rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
